import cookiejs from 'cookiejs';
import ui from '@alpinejs/ui'

import fileuploaderDocuments from "./fileuploader_documents";

document.addEventListener('alpine:init', function(){
  Alpine.plugin(ui);
  Alpine.plugin(fileuploaderDocuments);

  Alpine.magic('cookiejs', () => cookiejs);
})
